import React, { FC } from 'react'
import classNames from 'classnames'
import { CaretDownIcon } from '@/atoms/Icons/CaretDownIcon'
import { useTranslate } from '@/utils/translate/translate-client'
import { GEyebrowMD } from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'

interface Props {
  onClick: () => void
  className?: string
}

export const LearnMoreButton: FC<Props> = ({ onClick, className }) => {
  const { t } = useTranslate('tickets')

  return (
    <button className={classNames('cursor-pointer flex-col justify-center md:flex', className)} onClick={onClick}>
      <GEyebrowMD color="white">
        <span style={{ textShadow: '1px 1px 0px rgba(0,0,0, 0.5)' }}>{t('learnMore', 'Learn More')}</span>
      </GEyebrowMD>
      <div className="mx-auto mt-2 w-fit rounded-full bg-white/20 p-[10px] backdrop-blur">
        <CaretDownIcon size={20} color="white" />
      </div>
    </button>
  )
}
